// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.earnings-container .sub-title-div {
  font-weight: bold;
  font-size: 24px;
  line-height: 24px;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
  margin: 30px 0 20px 0px;
}
.earnings-container .listing-header {
  display: flex;
  justify-content: space-between;
  padding: 0.3125rem 0 1.5625rem 0;
}
.earnings-container .listing-header .title-div {
  font-weight: bold;
  line-height: 1.75rem;
  font-size: 1.75rem;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
}
.earnings-container .earnings-section {
  display: flex;
}
.earnings-container .earnings-div {
  background: var(--ion-color-primary);
  width: 48%;
  min-height: 140px;
  padding: 25px;
  color: var(--ion-color-primary-white);
  position: relative;
}
.earnings-container .earning-icon,
.earnings-container .commission-icon {
  position: absolute;
  right: 25px;
  top: 25px;
}
.earnings-container .total-title {
  font-size: 14px;
  margin-top: 16px;
}
.earnings-container .value-title {
  font-size: 16px;
  font-weight: bold;
}
.earnings-container .admin-commission-div {
  min-width: 48%;
  min-height: 140px;
  background: var(--ion-app-light-orange);
  padding: 25px;
  color: var(--ion-color-primary-white);
  position: relative;
}
.earnings-container .admin-commission-class {
  display: flex;
}
.earnings-container .seperator {
  border: solid 1px var(--ion-color-primary-white);
  opacity: 0.3;
  margin: 20px 12px 0 12px;
}
.earnings-container .space-div {
  width: 4%;
}
.earnings-container .earnings-title {
  font-weight: 600;
  font-size: 24px;
  line-height: 33px;
  white-space: nowrap;
  width: 85%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.earnings-container .payable-amount-div {
  width: 100%;
  height: 81px;
  background: var(--ion-dark-grey);
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
.earnings-container .payable-title {
  font-size: 24px;
  line-height: 33px;
  color: var(--ion-color-primary-white);
  padding: 25px;
}
.earnings-container .payable-title .payable-value {
  font-weight: 600;
}
.earnings-container .payable-button {
  width: 154px;
  height: 41px;
  background: var(--ion-color-primary);
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0px;
  color: var(--ion-color-primary-white);
  text-transform: uppercase;
  align-self: center;
  text-align: center;
  padding-top: 11px;
  margin: 25px;
  cursor: pointer;
}
.earnings-container .listing-table {
  padding: 0 0 1.25rem;
  overflow-x: auto;
}
.earnings-container .listing-table .table {
  width: 100%;
}
.earnings-container .listing-table .table .column-heading {
  font-weight: 500;
  font-size: 0.975rem;
  line-height: 1rem;
  text-transform: uppercase;
  color: var(--ion-grey1);
  padding: 0.5625rem 0.5625rem 0.5625rem 0;
  width: 20%;
  cursor: pointer;
}
.earnings-container .listing-table .table .status-col {
  max-width: 110px;
  width: 100px;
}
.earnings-container .listing-table .table .ship-to-col {
  min-width: 100px;
  max-width: 244px;
}
.earnings-container .listing-table .table .thead {
  border-bottom: 1px solid var(--ion-color-primary-border);
}
.earnings-container .listing-table .table .table-body .table-row {
  border-bottom: 1px solid var(--ion-color-primary-border);
}
.earnings-container .listing-table .table .table-body .table-row td {
  padding: 0.5625rem 0.5625rem 0.5625rem 0;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  color: var(--ion-color-primary-black);
}
.earnings-container .listing-table .table .table-body .table-row .right-arrow {
  display: flex;
  align-items: center;
}

.justify-end {
  justify-content: flex-end;
}

.justify-start {
  justify-content: flex-start;
}

@media (max-width: 767px) {
  .earnings-container .earnings-section {
    display: block;
  }
  .earnings-container .earnings-title,
  .earnings-container .payable-title {
    font-size: 18px;
  }
  .earnings-container .payable-button {
    height: 50px;
    font-size: 12px;
  }
  .earnings-container .payable-amount-div {
    height: 130px;
  }
  .earnings-container .earnings-div {
    width: 100%;
    margin-bottom: 30px;
  }
  .earnings-container .value-title {
    font-size: 12px;
  }
  .earnings-container .admin-commission-div,
  .earnings-div {
    width: 100%;
    height: 172px;
  }
}
.pagination-wrapper {
  max-width: 1400px;
  margin: auto;
  text-align: center;
}

.pagination-div {
  align-items: center;
}

.pagination-grid {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin: 1.25rem 0;
}
.pagination-grid-tile {
  width: 33%;
  padding: 0;
}

.perpage-dropdown {
  display: flex;
  align-items: center;
}
.perpage-dropdown ion-item {
  font: normal normal 600 0.875rem/21px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}

.perpage-title {
  font: normal normal normal 0.875rem/21px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}

.pagination-col {
  text-align: left;
}

.printer-icon {
  align-items: center;
  display: flex;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/earnings/earnings.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAGC;EACC,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,0BAAA;EACA,uBAAA;AAFF;AAKC;EACC,aAAA;EACA,8BAAA;EACA,gCAAA;AAHF;AAKE;EACC,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qCAAA;EACA,0BAAA;AAHH;AAOC;EACC,aAAA;AALF;AAQC;EACC,oCAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;EACA,qCAAA;EACA,kBAAA;AANF;AASC;;EAEC,kBAAA;EACA,WAAA;EACA,SAAA;AAPF;AAUC;EACC,eAAA;EACA,gBAAA;AARF;AAWC;EACC,eAAA;EACA,iBAAA;AATF;AAYC;EACC,cAAA;EACA,iBAAA;EACA,uCAAA;EACA,aAAA;EACA,qCAAA;EACA,kBAAA;AAVF;AAaC;EACC,aAAA;AAXF;AAcC;EACC,gDAAA;EACA,YAAA;EACA,wBAAA;AAZF;AAeC;EACC,SAAA;AAbF;AAgBC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;AAdF;AAiBC;EACC,WAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;AAfF;AAkBC;EACC,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,aAAA;AAhBF;AAkBE;EACC,gBAAA;AAhBH;AAoBC;EACC,YAAA;EACA,YAAA;EACA,oCAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AAlBF;AAqBC;EACC,oBAAA;EACA,gBAAA;AAnBF;AAqBE;EACC,WAAA;AAnBH;AAqBG;EACC,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wCAAA;EACA,UAAA;EACA,eAAA;AAnBJ;AAsBG;EACC,gBAAA;EACA,YAAA;AApBJ;AAuBG;EACC,gBAAA;EACA,gBAAA;AArBJ;AAwBG;EACC,wDAAA;AAtBJ;AA0BI;EACC,wDAAA;AAxBL;AA0BK;EACC,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;AAxBN;AA2BK;EACC,aAAA;EACA,mBAAA;AAzBN;;AAkCA;EACC,yBAAA;AA/BD;;AAkCA;EACC,2BAAA;AA/BD;;ACdQ;EDiDP;IACC,cAAA;EA/BA;EAkCD;;IAGC,eAAA;EAjCA;EAoCD;IACC,YAAA;IACA,eAAA;EAlCA;EAqCD;IACC,aAAA;EAnCA;EAsCD;IACC,WAAA;IACA,mBAAA;EApCA;EAuCD;IACC,eAAA;EArCA;EAwCD;;IAEC,WAAA;IACA,aAAA;EAtCA;AACF;AAyCA;EACC,iBAAA;EACA,YAAA;EACA,kBAAA;AAvCD;;AA0CA;EACC,mBAAA;AAvCD;;AA0CA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AAvCD;AAyCC;EACC,UAAA;EACA,UAAA;AAvCF;;AA4CA;EACC,aAAA;EACA,mBAAA;AAzCD;AA6CC;EACC,+CAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AA3CF;;AA+CA;EACC,kDAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AA5CD;;AA+CA;EACC,gBAAA;AA5CD;;AA+CA;EACC,mBAAA;EACA,aAAA;EACA,eAAA;AA5CD","sourcesContent":["@import \"src/theme/mixins.scss\";\n\n.earnings-container {\n\t.sub-title-div {\n\t\tfont-weight: bold;\n\t\tfont-size: 24px;\n\t\tline-height: 24px;\n\t\tcolor: var(--ion-color-primary-black);\n\t\ttext-transform: capitalize;\n\t\tmargin: 30px 0 20px 0px;\n\t}\n\n\t.listing-header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 0.3125rem 0 1.5625rem 0;\n\n\t\t.title-div {\n\t\t\tfont-weight: bold;\n\t\t\tline-height: 1.75rem;\n\t\t\tfont-size: 1.75rem;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\ttext-transform: capitalize\n\t\t}\n\t}\n\n\t.earnings-section {\n\t\tdisplay: flex;\n\t}\n\n\t.earnings-div {\n\t\tbackground: var(--ion-color-primary);\n\t\twidth: 48%;\n\t\tmin-height: 140px;\n\t\tpadding: 25px;\n\t\tcolor: var(--ion-color-primary-white);\n\t\tposition: relative;\n\t}\n\n\t.earning-icon,\n\t.commission-icon {\n\t\tposition: absolute;\n\t\tright: 25px;\n\t\ttop: 25px;\n\t}\n\n\t.total-title {\n\t\tfont-size: 14px;\n\t\tmargin-top: 16px;\n\t}\n\n\t.value-title {\n\t\tfont-size: 16px;\n\t\tfont-weight: bold;\n\t}\n\n\t.admin-commission-div {\n\t\tmin-width: 48%;\n\t\tmin-height: 140px;\n\t\tbackground: var(--ion-app-light-orange);\n\t\tpadding: 25px;\n\t\tcolor: var(--ion-color-primary-white);\n\t\tposition: relative;\n\t}\n\n\t.admin-commission-class {\n\t\tdisplay: flex;\n\t}\n\n\t.seperator {\n\t\tborder: solid 1px var(--ion-color-primary-white);\n\t\topacity: 0.3;\n\t\tmargin: 20px 12px 0 12px;\n\t}\n\n\t.space-div {\n\t\twidth: 4%;\n\t}\n\n\t.earnings-title {\n\t\tfont-weight: 600;\n\t\tfont-size: 24px;\n\t\tline-height: 33px;\n\t\twhite-space: nowrap;\n\t\twidth: 85%;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\t.payable-amount-div {\n\t\twidth: 100%;\n\t\theight: 81px;\n\t\tbackground: var(--ion-dark-grey);\n\t\tmargin-top: 30px;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n\n\t.payable-title {\n\t\tfont-size: 24px;\n\t\tline-height: 33px;\n\t\tcolor: var(--ion-color-primary-white);\n\t\tpadding: 25px;\n\n\t\t.payable-value {\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n\n\t.payable-button {\n\t\twidth: 154px;\n\t\theight: 41px;\n\t\tbackground: var(--ion-color-primary);\n\t\tfont-weight: bold;\n\t\tfont-size: 14px;\n\t\tline-height: 19px;\n\t\tletter-spacing: 0px;\n\t\tcolor: var(--ion-color-primary-white);\n\t\ttext-transform: uppercase;\n\t\talign-self: center;\n\t\ttext-align: center;\n\t\tpadding-top: 11px;\n\t\tmargin: 25px;\n\t\tcursor: pointer;\n\t}\n\n\t.listing-table {\n\t\tpadding: 0 0 1.25rem;\n\t\toverflow-x: auto;\n\n\t\t.table {\n\t\t\twidth: 100%;\n\n\t\t\t.column-heading {\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 0.975rem;\n\t\t\t\tline-height: 1rem;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tcolor: var(--ion-grey1);\n\t\t\t\tpadding: 0.5625rem 0.5625rem 0.5625rem 0;\n\t\t\t\twidth: 20%;\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\t.status-col {\n\t\t\t\tmax-width: 110px;\n\t\t\t\twidth: 100px;\n\t\t\t}\n\n\t\t\t.ship-to-col {\n\t\t\t\tmin-width: 100px;\n\t\t\t\tmax-width: 244px;\n\t\t\t}\n\n\t\t\t.thead {\n\t\t\t\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\t\t\t}\n\n\t\t\t.table-body {\n\t\t\t\t.table-row {\n\t\t\t\t\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\n\t\t\t\t\ttd {\n\t\t\t\t\t\tpadding: 0.5625rem 0.5625rem 0.5625rem 0;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\tline-height: 1.5rem;\n\t\t\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\t\t}\n\n\t\t\t\t\t.right-arrow {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t}\n\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.justify-end {\n\tjustify-content: flex-end;\n}\n\n.justify-start {\n\tjustify-content: flex-start;\n}\n\n@include respond-below(md) {\n\t.earnings-container .earnings-section {\n\t\tdisplay: block;\n\t}\n\n\t.earnings-container .earnings-title,\n\t.earnings-container .payable-title {\n\n\t\tfont-size: 18px;\n\t}\n\n\t.earnings-container .payable-button {\n\t\theight: 50px;\n\t\tfont-size: 12px;\n\t}\n\n\t.earnings-container .payable-amount-div {\n\t\theight: 130px;\n\t}\n\n\t.earnings-container .earnings-div {\n\t\twidth: 100%;\n\t\tmargin-bottom: 30px;\n\t}\n\n\t.earnings-container .value-title {\n\t\tfont-size: 12px;\n\t}\n\n\t.earnings-container .admin-commission-div,\n\t.earnings-div {\n\t\twidth: 100%;\n\t\theight: 172px;\n\t}\n}\n\n.pagination-wrapper {\n\tmax-width: 1400px;\n\tmargin: auto;\n\ttext-align: center;\n}\n\n.pagination-div {\n\talign-items: center;\n}\n\n.pagination-grid {\n\tdisplay: flex;\n\tflex-flow: row wrap;\n\tjustify-content: space-between;\n\tmargin: 1.25rem 0;\n\n\t&-tile {\n\t\twidth: 33%;\n\t\tpadding: 0;\n\t}\n}\n\n\n.perpage-dropdown {\n\tdisplay: flex;\n\talign-items: center;\n\n\t// position: absolute;\n\t// bottom: 2%;\n\tion-item {\n\t\tfont: normal normal 600 0.875rem /21px Noto Sans;\n\t\tletter-spacing: 0;\n\t\tcolor: var(--ion-color-primary-black);\n\t\topacity: 1;\n\t}\n}\n\n.perpage-title {\n\tfont: normal normal normal 0.875rem /21px Noto Sans;\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-primary-black);\n\topacity: 1;\n}\n\n.pagination-col {\n\ttext-align: left;\n}\n\n.printer-icon {\n\talign-items: center;\n\tdisplay: flex;\n\tcursor: pointer;\n}","// custom fons facemizxin\n\n@mixin font-face($font-family, $url) {\n    @font-face {\n        font-family: '#{$font-family}';\n        src: url('#{$url}.eot');\n        src: url('#{$url}.eot?#iefix') format('embedded-opentype'),\n        url('#{$url}.woff') format('woff'),\n        url('#{$url}.ttf') format('truetype'),\n        url('#{$url}.svg') format('svg');\n        font-weight: normal;\n        font-style: normal;\n    }\n}\n\n\n\n//custom font resposnive muin\n$font-base-min: 14px;\n$font-base-max: 6;\n$breakmin: 320px;\n$breakmax: 768px;\n$customSize: 5px;\n\n@mixin font-responsive($fmin, $fdiff, $breakmin, $breakdiff) {\n    font-size: calc(#{$fmin} + #{$fdiff} * ((100vw - #{$breakmin}) / #{$breakdiff}));\n\n    @media(max-width: $breakmin) {\n        font-size: $fmin;\n    }\n\n    @media(min-width: round($breakmin + $breakmax)) {\n        font-size: round($fmin + $fdiff);\n    }\n\n    @media(max-width: $breakmax) {\n        // font-size: round($fmin + 3px);\n        font-size: calc(#{$fmin} + #{$customSize});\n    }\n}\n\n\n// custom font source mmixins\n\n@mixin font($colour: false, $weight: false, $lh: false, $spacing: false) {\n\n    // @if $size { font-size: $size; }\n    @if $colour {\n        color: $colour;\n    }\n\n    @if $weight {\n        font-weight: $weight;\n    }\n\n    @if $lh {\n        line-height: $lh;\n    }\n\n    @if $spacing {\n        letter-spacing: $spacing;\n    }\n}\n\n\n// custom input placeholder mixins\n\n@mixin input-placeholder {\n    &.placeholder {\n        @content;\n    }\n\n    &:-moz-placeholder {\n        @content;\n    }\n\n    &::-moz-placeholder {\n        @content;\n    }\n\n    &:-ms-input-placeholder {\n        @content;\n    }\n\n    &::-webkit-input-placeholder {\n        @content;\n    }\n}\n\n\n// A map of breakpoints.\n$breakpoints: (\n    xs: 480px,\n    sm: 576px,\n    md: 768px,\n    lg: 992px,\n    xl: 1200px,\n    xxl: 1600px,\n    ipadSize: 768px,\n    ipadmin:481px,\n    ipadmax:1024px,\n    ipadlandscape:1320px,\n\n);\n\n// Respond above.\n@mixin respond-above($breakpoint) {\n\n    // If the breakpoint exists in the map.\n    @if map-has-key($breakpoints, $breakpoint) {\n\n        // Get the breakpoint value.\n        $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n        // Write the media query.\n        @media (min-width: $breakpoint-value) {\n            @content;\n        }\n\n        // If the breakpoint doesn't exist in the map.\n    }\n\n    @else {\n\n        // Log a warning.\n        @warn 'Invalid breakpoint: #{$breakpoint}.';\n    }\n}\n\n\n\n\n@mixin respond-below($breakpoint) {\n\n    // If the breakpoint exists in the map.\n    @if map-has-key($breakpoints, $breakpoint) {\n\n        // Get the breakpoint value.\n        $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n        // Write the media query.\n        @media (max-width: ($breakpoint-value - 1)) {\n            @content;\n        }\n\n        // If the breakpoint doesn't exist in the map.\n    }\n\n    @else {\n\n        // Log a warning.\n        @warn 'Invalid breakpoint: #{$breakpoint}.';\n    }\n}\n\n\n\n@mixin respond-between($lower, $upper) {\n\n    // If both the lower and upper breakpoints exist in the map.\n    @if map-has-key($breakpoints, $lower) and map-has-key($breakpoints, $upper) {\n\n        // Get the lower and upper breakpoints.\n        $lower-breakpoint: map-get($breakpoints, $lower);\n        $upper-breakpoint: map-get($breakpoints, $upper);\n\n        // Write the media query.\n        @media (min-width: $lower-breakpoint) and (max-width: ($upper-breakpoint - 1)) {\n            @content;\n        }\n\n        // If one or both of the breakpoints don't exist.\n    }\n\n    @else {\n\n        // If lower breakpoint is invalid.\n        @if (map-has-key($breakpoints, $lower)==false) {\n\n            // Log a warning.\n            @warn 'Your lower breakpoint was invalid: #{$lower}.';\n        }\n\n        // If upper breakpoint is invalid.\n        @if (map-has-key($breakpoints, $upper)==false) {\n\n            // Log a warning.\n            @warn 'Your upper breakpoint was invalid: #{$upper}.';\n        }\n    }\n}\n\n\n// @media only screen and (device-width: 768px) {}\n\n// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:portrait) {}\n\n// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape) {\n//     /* For landscape layouts only */\n// }\n\n/// vernodr prefixes\n\n@mixin css3-prefix($prop, $value) {\n    -webkit-#{$prop}: #{$value};\n    -moz-#{$prop}: #{$value};\n    -ms-#{$prop}: #{$value};\n    -o-#{$prop}: #{$value};\n    #{$prop}: #{$value};\n}\n\n\n//  vertical cneter\n@mixin vertical-center {\n    position: relative;\n    top: 50%;\n    -ms-transform: translateY(-50%);\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n}\n\n//keyframe miins\n\n@mixin keyframes($name) {\n    @-webkit-keyframes #{$name} {\n        @content;\n    }\n\n    @-moz-keyframes #{$name} {\n        @content;\n    }\n\n    @keyframes #{$name} {\n        @content;\n    }\n}\n\n//absolute positoning\n\n@mixin abs-position ($top, $right, $bottom, $left) {\n    position: absolute;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n\n//arrow minis\n@mixin arrow($direction: down, $size: 5px, $color: #555) {\n    width: 0;\n    height: 0;\n\n    @if ($direction ==left) {\n        border-top: $size solid transparent;\n        border-bottom: $size solid transparent;\n        border-right: $size solid $color;\n    }\n\n    @else if ($direction ==right) {\n        border-top: $size solid transparent;\n        border-bottom: $size solid transparent;\n        border-left: $size solid $color;\n    }\n\n    @else if ($direction ==down) {\n        border-left: $size solid transparent;\n        border-right: $size solid transparent;\n        border-top: $size solid $color;\n    }\n\n    @else {\n        border-left: $size solid transparent;\n        border-right: $size solid transparent;\n        border-bottom: $size solid $color;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
